import React from 'react'
import Layer from './Layer'

const BicyclingLayer = ({}) => <Layer type="bicycling" />

BicyclingLayer.displayName = 'BicyclingLayer'

export default BicyclingLayer
